import { alsAnzeige } from "../hilfen/formelrechner";
import { formatiere } from "../hilfen/zahlformat";
import { zellschluessel } from "../hilfen/zellbezug";

/*
  Das Blatt auf Papier.

  ---------------------------------------------------------------
  Warum ein zweiter Stapel und nicht das Blatt von oben
  ---------------------------------------------------------------

  Das bearbeitbare Blatt steckt in einem eigenen Scrollkasten mit
  begrenzter Höhe — genau das braucht es, damit die Köpfe beim Scrollen
  stehen bleiben. Auf Papier ist ein Kasten mit Scrollbalken aber sinnlos:
  Es käme nur der sichtbare Ausschnitt heraus.

  Deshalb hier ein zweites, schlichtes `<table>` ohne Kasten und ohne
  Fixierung. `<thead>` wiederholt der Browser von sich aus auf jeder Seite —
  das ist der eine Grund, aus dem hier ein echtes `<table>` steht und kein
  Raster aus Kästen.

  ---------------------------------------------------------------
  Was aufs Papier kommt
  ---------------------------------------------------------------

  Die ANGEZEIGTEN Werte, nicht die Formeln. Wer ein Handout für die
  Fraktionssitzung ausdruckt, will Beträge lesen, keine Rechenwege.

  ---------------------------------------------------------------
  Zeile 1 ist die Überschrift
  ---------------------------------------------------------------

  Sie wandert in den `<thead>` und wiederholt sich damit auf jeder Seite.
  Das ist die Gewohnheit, der fast jede Tabelle folgt — und die einzige
  Möglichkeit, die Wiederholung überhaupt sinnvoll zu füllen.

  Wer dort Daten stehen hat, sieht sie auf Papier als Überschrift: fett und
  grau hinterlegt. Verloren geht nichts, aber es sieht anders aus als auf
  dem Bildschirm. Das ist der Preis der Wiederholung, und er ist notiert.

  Die Spaltenbuchstaben stehen NICHT dabei: A, B, C helfen beim Bearbeiten,
  auf Papier sind sie Ballast. Eine leere Überschriftenzelle bleibt leer —
  ein eingesprungenes „A" neben echten Überschriften sähe willkürlich aus.
*/

export default function Tabellendruck({ gitter, werte, titel }) {
  return (
    <div className="tabellendruck">
      <h1 className="tabellendruck__titel">{titel}</h1>

      <table className="tabellendruck__blatt">
        <thead>
          <tr>
            {gitter.spalten.map((spalte) => {
              const kopfWert = gitter.zeilen[0]
                ? werte.get(zellschluessel(spalte.id, gitter.zeilen[0].id))
                : null;
              const kopf = alsAnzeige(kopfWert);
              return (
                <th key={spalte.id} scope="col">
                  {kopf.zahl !== null ? formatiere(kopf.zahl, spalte.format) : kopf.text}
                </th>
              );
            })}
          </tr>
        </thead>

        <tbody>
          {/* Zeile 1 steht schon als Kopf — sie darf nicht doppelt kommen. */}
          {gitter.zeilen.slice(1).map((zeile) => (
            <tr key={zeile.id}>
              {gitter.spalten.map((spalte) => {
                const wert = werte.get(zellschluessel(spalte.id, zeile.id));
                const anzeige = alsAnzeige(wert);
                return (
                  <td
                    key={spalte.id}
                    className={anzeige.zahl !== null ? "tabellendruck__zahl" : ""}
                  >
                    {anzeige.zahl !== null
                      ? formatiere(anzeige.zahl, spalte.format)
                      : anzeige.text}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
